import { useEffect, useRef, useState } from 'react';
import './CustomisationWorkspaceMain.scss';
import { WorkspaceConfig } from './DisruptorConfigFiles/WorkspaceConfig';
import NodeList, { NODE_LIST_CONTROLLER } from '../../NodeList/NodeList';
import { WORKSPACE_LEFT_LIST_ICONS } from './WorkspaceAssets/Assets';
import Timeline from './WorkspaceComponents/Timeline/Timeline';
import EditablePreview, { getCustomisationFieldData, getCustomisationValue, updateCustomisationValue } from './WorkspaceComponents/EditablePreview/EditablePreview';
import ModuleList, { changeValue_noType } from './WorkspaceComponents/ModuleList/ModuleList';
import FontSelectorPopup from '../../forms/FontSelector/FontSelectorPopup';
import { initGoogleFonts } from '../../../helpers/Fonts';
import CustomFontsPopup from '../../../containers/CustomiseFeature/CustomFontsPopup';
import TemporaryImageUploadPopup from './TemporaryImageUploadPopup/TemporaryImageUploadPopup';
import FeaturePreview, { postMessageToPreviewFrame } from '../../FeaturePreview/FeaturePreview';
import axios from '../../../api/axios';
import { getCampaignFeatureVarsRoute, updateCampaignFeatureVarsRoute } from '../../../api/routes';
import { toast } from 'react-toastify';
import { POST_MESSAGE_OUT_TYPES } from '../../../helpers/FeatureControlsHelper';
import { getFeatureAssetBaseUrl } from '../../../helpers/FeatureAssets';
import { CUSTOMISED_URL_MAP } from '../../../config/FeatureDashboardVarMap';
import { RIGHT_CLICK_MENU_CONTROLLER } from '../../RightClickMenu/RightClickMenu';
import TemporaryAudioUploadPopup from './TemporaryAudioUploadPopup/TemporaryAudioUploadPopup';

const CustomisationWorkspaceMain = (props) => {
    // console.log("CustomisationWorkspaceMain props:", props);
    const workspaceConfig = props.previewCustomisationConfig || WorkspaceConfig
    const campaignData = props.campaignData || null;
    const customisationVars = props.customisationVars || null;

    const [previewMode, setPreviewMode] = useState(false);
    const [featureVars, setFeatureVars] = useState({});
    const featureVarsRef = useRef(null);
    const getFeatureVars = () => {
        console.log('Get Campaign Feature Vars');
        axios
            .get(getCampaignFeatureVarsRoute, {
                params: { campaignID: campaignData._id },
                withCredentials: true
            })
            .then(function (response) {
                console.log('CAMPAIGN STREAM VARS', response.data);
                if (response.data.streamVars) {
                    featureVarsRef.current = response.data.streamVars;
                    setFeatureVars(featureVarsRef.current);
                }
                // getCustomisationVars();
            })
            .catch(function (error) {
                toast.error('Error - ' + error);
                // console.log(error.response)
            });
    }

    const addVal = (valsArray, varSchema, featureData) => {
        // console.log('--- Adding vals: ', valsArray, varSchema);
        // if (validateLastVal(valsArray)) {
            const newValObj = {};
            for (let prop in varSchema) {
                const type = varSchema[prop].type.toLowerCase();
                switch (type) {
                    case 'video':
                    case 'image':
                    case 'audio':
                        // These need formatting properly!
                        const filename = (varSchema[prop].hasOwnProperty('default') || varSchema[prop].hasOwnProperty('defaultVal')) ? (varSchema[prop].default ?? varSchema[prop].defaultVal) : null;
                        if (props.isFullPreview === true) {
                            // In full preview mode the filename has already been formatted to an object
                            newValObj[prop] = filename;
                        } else {
                            const fileObj = {
                                filename: filename,
                                isDefault: true,
                                originalFile: filename,
                                type: type,
                                srcUrl: (typeof filename === 'undefined' || filename === null || filename === '') ? null :
                                    getFeatureAssetBaseUrl()
                                    + featureData.defaultAssetFolder 
                                    + '/' + CUSTOMISED_URL_MAP[type].dir + '/' 
                                    + filename,
                                
                                /* filesRoute + '/' + CUSTOMISED_ASSETS_BASE_URL + '/' 
                                        + props.featureData.feature.defaultAssetFolder 
                                        + '/' + CUSTOMISED_URL_MAP[type].dir + '/' 
                                        + filename */
                            };
                            newValObj[prop] = fileObj;
                        }
                        break;
                    default:
                        newValObj[prop] = (varSchema[prop].hasOwnProperty('default') || varSchema[prop].hasOwnProperty('defaultVal')) ? (varSchema[prop].default ?? varSchema[prop].defaultVal) : null;
                }
            }
            valsArray.push(newValObj);
            // console.log('Added val: ', valsArray, props.customisationVars);
            // setFeatureState({ ...props.customisationVars });
            forceUpdateComponent();
        // }
    }
    
    const removeVal = (valsArray, index) => {
        // console.log('Remove val: ', valsArray, index, objRef);
        if (valsArray.length > 1) {
            /* if (props.handleRemovedFile) {
                props.handleRemovedFile(valsArray[index]);
            } */
            // valsArray.splice(index, 1);
            
            // create a new array instance so we can make sure we see the correct data next render
            /* const oldArray = objRef.propRef[objRef.prop];
            const newArray = [];
            for (let i = 0; i < oldArray.length; i++) {
                if (i !== index) {
                    newArray.push({...oldArray[i]});
                }
            } */
            // Lets force this stubborn component to update!
            // The component should be using useEffect really, but what if it isn't implemented very well in it?
            // objRef.propRef[objRef.prop] = [];
            // setFeatureState({ ...props.customisationVars });
            // Above forces a re-render where there are no vals, so the components will vanish for a split second
            // The timeout below brings em back (looking correct)
            /* setTimeout(
                () => {
                    objRef.propRef[objRef.prop] = newArray;
                    setFeatureState({ ...props.customisationVars });
                },
                10
            ) */
            // console.log('Val removed: ', valsArray, index, props.customisationVars);

            // objRef.propRef[objRef.prop] = newArray;
            valsArray.splice(index, 1);
            forceUpdateComponent();
        }
    }

    const updateFeatureVars = (updatedVars) => {
        axios
            .post(updateCampaignFeatureVarsRoute, {
                campaignID: campaignData._id,
                updatedVars: updatedVars,
                withCredentials: true
            })
            .then(function (response) {
                console.log(response.data);
            })
            .catch(function (error) {
                toast.error('Error - ' + error);
            });
    }
    useEffect(getFeatureVars, [campaignData]);

    const sendFeatureCommand = (e, commandString, featureId, param = null) => {
        if (e) {
            e.preventDefault();
        }
        /* if (BUTTON_FUNCTIONS[commandString]) {
            console.log('Running button function: ', commandString, featureId, param);
            BUTTON_FUNCTIONS[commandString](featureId, param);
        } else { */
            postMessageToPreviewFrame(POST_MESSAGE_OUT_TYPES.COMMAND_RECEIVED, { command: commandString, extraData: {username:'CampignStudio', hashtag:'Manual Press', commandParam: param} });
        // }
    }

    const [leftListItems, setLeftListItems] = useState(null);
    const [activeNode, setActiveNode] = useState(null);
    const [activeTimelineAudioGroup, setActiveTimelineAudioGroup] = useState(null);
    const [activeVisualisedPreviewNode, setActiveVisualisedPreviewNode] = useState(null);
    const activeVisualisedPreviewNode_ref = useRef(activeVisualisedPreviewNode);
    useEffect(() => {
        activeVisualisedPreviewNode_ref.current = activeVisualisedPreviewNode;
    }, [activeVisualisedPreviewNode]);
    const [selectedFeatureId, setSelectedFeatureId] = useState(props.featureId);
    const [selectedFeatureNode, setSelectedFeatureNode] = useState(null);
    const [selectedFeature, setSelectedFeature] = useState(null);
    useEffect(() => {
        console.log("CustomisationWorkspaceMain useEffect - selectedFeatureNode:", selectedFeatureNode);
        let selectedFeature = null;
        if (selectedFeatureNode) {
            selectedFeature = campaignData.features.find(feature => feature._id === selectedFeatureNode.id);
        }
        setSelectedFeature(selectedFeature);
    }, [selectedFeatureNode]);
    const [timelinePlayheadStep, setTimelinePlayheadStep] = useState(0);

    const [forceUpdate, setForceUpdate] = useState(0);
    const forceUpdateComponent = () => {
        setForceUpdate((oldVal) => oldVal + 1);
    }

    useEffect(() => {
        if (leftListItems === null) {
            const newListItems = leftListItems || [];
            console.log("CustomisationWorkspaceMain useEffect - campaignData:", campaignData);
            for (let i = 0; i < campaignData.features.length; i++) {
                if (workspaceConfig[campaignData.features[i].varKey]) {
                    const feature = campaignData.features[i];
                    const featureConfig = workspaceConfig[feature.varKey];
                    console.log("CustomisationWorkspaceMain useEffect - featureConfig:", feature, featureConfig);
                    if (featureConfig) {
                        const newItem = {
                            id: feature._id,
                            path: feature._id,
                            name: feature.contentLabel,
                            varKey: feature.varKey,
                            config: featureConfig,
                            featureData: feature,
                            customisationVars: customisationVars?.current?.[feature._id] ? customisationVars.current[feature._id] : null,
                            hasChildren: false,
                            enabled: true,
                            selected: selectedFeatureId === feature._id,
                            expanded: selectedFeatureId === feature._id,
                            subNodes: [],
                            icon: "feature",
                            depth: 0,
                        }

                        if (featureConfig?.customisation?.groups && featureConfig.customisation.groups.length > 0) {
                            newItem.hasChildren = true;
                            processGroupsToSubNodes(featureConfig.customisation.groups, newItem, newItem);
                        }

                        newListItems.push(newItem);
                        console.log("CustomisationWorkspaceMain useEffect - newItem:", newItem, newListItems);
                    }
                }
            }
            setLeftListItems(newListItems);
            console.log("CustomisationWorkspaceMain useEffect - leftListItems:", newListItems);
        }
    }, []);
    const processGroupsToSubNodes = (groups, parent, topNode, lastTopVisualisedNode = null) => {
        console.log("processGroupsToSubNodes - groups:", groups, "parent:", parent);

        processFixedSettings(groups, topNode);

        for (let i = 0; i < groups.length; i++) {
            if (groups[i].type === 'group') {
                console.log("processGroupsToSubNodes - group:", groups[i]);
                const group = groups[i];
                const newSubNode = {
                    id: parent.id + '-' + group.name.split(' ').join('_'),
                    path: parent.path + '.' + group.name.split(' ').join('_'),
                    name: group.name,
                    config: group,
                    featureData: parent.featureData,
                    customisationVars: parent.customisationVars,
                    topNode: topNode,
                    hasChildren: group.children && group.children.length > 0,
                    enabled: true,
                    subNodes: [],
                    depth: parent.depth + 1,
                    parent: parent,
                }

                let iconType = null;
                console.log("Decide icon type for group:", group, "parent:", parent, "children:", group.children);
                if (group.type === 'group') {
                    if (parent.isVisualised || group?.visualisationConfig?.isEnabled) {
                        iconType = 'visualisedGroup';
                        newSubNode.isVisualised = true;
                        if (newSubNode?.config?.visualisationConfig?.isEnabled) {
                            lastTopVisualisedNode = newSubNode;
                        } else {
                            newSubNode.visualisedTopNode = lastTopVisualisedNode;
                        }
                    } else {
                        iconType = 'basicGroup';
                    }

                    let iconSet = false;
                    // If we have a custom module (child.module === 'custom'), check if we have an ImageUpload field
                    if (group.children && group.children.length > 0 && group.children.some(child => child.module === 'custom') ) {
                        const customModule = group.children.find(child => child.module === 'custom');
                        console.log("Custom module found:", customModule);
                        if (customModule.fields && customModule.fields.some(field => field?.customFieldConfig?.customFieldType === 'ImageUpload')) {
                            iconType = 'image';
                            iconSet = true;
                        }
                    }
                    if (!iconSet) {
                        // Do we have a copy field (text) child?
                        if (group.children && group.children.length > 0 && group.children.some(child => child.module === 'copy')) {
                            iconType = 'text';
                        } else if (group.children && group.children.length > 0 && group.children.some(child => child.module === 'image')) {
                            iconType = 'image';
                        } else if (group.name.toLowerCase().includes(' bar')) {
                            iconType = 'progressBar';
                        }
                    }
                }

                if (iconType) {
                    newSubNode.icon = iconType;
                }

                parent.subNodes.push(newSubNode);
                if (parent !== topNode && parent.subNodes.length > 1) {
                    parent.icon = 'basicGroup';
                }
                if (group.children && group.children.length > 0) {
                    processGroupsToSubNodes(group.children, newSubNode, topNode, lastTopVisualisedNode);
                }
                
                if (group?.groupSettings?.dataLink) {
                    newSubNode.hasChildren = true;
                    newSubNode.dynamicSubNodes = true;
                    // These data links for for customisations that allow multiples, we need to set hasChildren to true and our node list will
                    // request the children which we can return as the list of multiple objects and an Add New option.
                }
            }
        }
    }

    const processFixedSettings = (modules, topNode) => {
        modules.forEach(module => {
            if (module.type === 'module' && module.fields) {
                // console.log("processFixedSettings - module:", module);
                module.fields.forEach(field => {
                    // console.log("processFixedSettings - field:", field);
                    if (field.customFieldConfig && field.customFieldConfig.fixedValue && field.customFieldConfig.dataLink) {
                        // Process fixed settings
                        const fixedValue = field.customFieldConfig.fixedValue;
                        const dataLink = field.customFieldConfig.dataLink;
                        console.log(">>> processFixedSettings - fixedValue:", fixedValue, "dataLink:", dataLink, customisationVars, topNode);
                        // Here you would typically set the customisation data based on the fixedValue and dataLink
                        updateCustomisationValue(topNode.customisationVars, dataLink, fixedValue);
                    }
                });
            }
        });
    }

    const getSubNodes = (node, nodes) => {
        // console.log('Default getSubNodes: ', node, nodes);
        const customisationConfig = getCustomisationFieldData(campaignData, node.topNode.id, node.config.groupSettings.dataLink);
        const customisationData = getCustomisationValue(node.customisationVars, node.config.groupSettings.dataLink, -1);
        // console.log("getSubNodes - customisationConfig:", customisationConfig, "customisationData:", customisationData);
        // return nodes.filter(n => n.parent === node.id);
        const newSubNodes = [];
        for (let i = 0; i < customisationData.length; i++) {
            const subNode = {...node};
            subNode.parent = node;
            subNode.depth = node.depth + 1;
            subNode.hasChildren = false;
            subNode.subNodes = null;
            subNode.dynamicSubNodes = false;
            subNode.isVisualised = false;
            subNode.id = node.id + '-' + (i + 1);
            subNode.path = node.path + '.' + (i + 1);
            subNode.name = node.name + ' ' + (i + 1);
            subNode.dataIndex = i;
            subNode.valsArray = customisationData;
            subNode.removable = true;
            subNode.topNode = node?.topNode ?? node;
            // subNode.visualisedTopNode = node?.visualisedTopNode ?? node;
            if (subNode.path === activeNode?.path) {
                subNode.active = true;
            } else {
                subNode.active = false;
            }
            newSubNodes.push(subNode);
        }

        const addButtonSubNode = {...node};
        addButtonSubNode.id = node.id + '-add';
        addButtonSubNode.path = node.path + '.add';
        addButtonSubNode.name = 'Add New';
        addButtonSubNode.dataIndex = -1;
        addButtonSubNode.hasChildren = false;
        addButtonSubNode.subNodes = null;
        addButtonSubNode.dynamicSubNodes = false;
        addButtonSubNode.active = false;
        addButtonSubNode.selected = false;
        addButtonSubNode.expanded = false;
        addButtonSubNode.isAddButton = true;
        addButtonSubNode.valsArray = customisationData;
        addButtonSubNode.varSchema = customisationConfig;
        addButtonSubNode.icon = 'add';
        newSubNodes.push(addButtonSubNode);

        return newSubNodes;
    }

    const clearActiveNode = () => {
        setActiveNode((oldVal) => {
            if (oldVal) {
                oldVal.active = false;
                NODE_LIST_CONTROLLER.refreshNodeList('customisation-workspace-left-list');
            }
            return null
        });
    }
    // The active node is the one we are going to display modules for in the right panel
    const activateNode = (node) => {
        console.log("activateNode - node:", node);
        clearActiveNode();
        setActiveTimelineAudioGroup(null);
        node.active = true;
        setActiveNode(node);

        expandParentNodes(node);
        NODE_LIST_CONTROLLER.refreshNodeList('customisation-workspace-left-list');
        
        if ((node.isVisualised && !node.visualisedTopNode) || node.visualisedTopNode) {
            const topVisualisedNode = node.visualisedTopNode || node;
            if (topVisualisedNode !== activeVisualisedPreviewNode_ref.current) {
                setActiveVisualisedPreviewNode(topVisualisedNode);
                console.log("activateNode - setting activeVisualisedPreviewNode:", topVisualisedNode);
            }
            if (node.isVisualised && node.config?.visualisationConfig?.restrictSteps) {
                // If this node is restricted to certain steps, we need to use it's step settings to move the playhead rather than the topVisualisedNode's step settings
                if (typeof node?.config?.visualisationConfig?.startStep === 'number' && typeof node?.config?.visualisationConfig?.endStep === 'number') {
                    setTimelinePlayheadStep(
                        (currentVal) => {
                            let newVal = currentVal;
                            if (newVal < node.config.visualisationConfig.startStep || newVal > node.config.visualisationConfig.endStep) {
                                newVal = node.config.visualisationConfig.startStep;
                            }
                            return newVal;
                        }
                    )
                    // setTimelinePlayheadStep(node.config.visualisationConfig.startStep);
                }
            } else
            if (typeof topVisualisedNode?.config?.visualisationConfig?.startStep === 'number' && typeof topVisualisedNode?.config?.visualisationConfig?.endStep === 'number') {
                setTimelinePlayheadStep(
                    (currentVal) => {
                        let newVal = currentVal;
                        if (newVal < topVisualisedNode.config.visualisationConfig.startStep || newVal > topVisualisedNode.config.visualisationConfig.endStep) {
                            newVal = topVisualisedNode.config.visualisationConfig.startStep;
                        }
                        return newVal;
                    }
                )
                // setTimelinePlayheadStep(node.config.visualisationConfig.startStep);
            }
        } else {
            setActiveVisualisedPreviewNode(null);
        }
        /* if (typeof node?.config?.visualisationConfig?.startStep === 'number') {
            setTimelinePlayheadStep(node.config.visualisationConfig.startStep);
        } */
    }
    const expandParentNodes = (node) => {
        // console.log("expandParentNode - node:", node);
        if (node.parent) {
            node.parent.expanded = true;
            expandParentNodes(node.parent);
        }
    }

    const activateTimelineAudioGroup = (audioGroupData) => {
        console.log("activateTimelineAudioGroup - audioGroupData:", audioGroupData);
        clearActiveNode();
        setActiveVisualisedPreviewNode(null);
        setActiveTimelineAudioGroup(audioGroupData);

        if ((typeof audioGroupData?.audioData?.startStep === 'number' || typeof audioGroupData?.audioData?.['trigger-step'] === 'number') && (typeof audioGroupData?.audioData?.endStep === 'number' || typeof audioGroupData?.audioData?.['end-step'] === 'number')) {
            setTimelinePlayheadStep(
                (currentVal) => {
                    let newVal = currentVal;
                    if (newVal < (audioGroupData?.audioData?.startStep ?? audioGroupData?.audioData?.['trigger-step']) || newVal > (audioGroupData?.audioData?.endStep ?? audioGroupData?.audioData?.['end-step'])) {
                        newVal = audioGroupData?.audioData?.startStep ?? audioGroupData?.audioData?.['trigger-step'];
                    }
                    return newVal;
                }
            )
            // setTimelinePlayheadStep(node.config.visualisationConfig.startStep);
        }
    }

    const renderNodeName = (nodeName, node, nodes, isExpandable) => {
        const addExtraIndentation = !isExpandable;
        if (node.icon) {
            return (
                <>
                    {node.icon === 'add' && <div className={`${addExtraIndentation ? 'v2-workspace__left-list-name-extra-indentation ' : ''}v2-workspace__left-list-img-icon`}>+</div>}
                    {node.icon !== 'add' &&
                        <img className={`${addExtraIndentation ? 'v2-workspace__left-list-name-extra-indentation ' : ''}v2-workspace__left-list-img-icon`} alt='' src={WORKSPACE_LEFT_LIST_ICONS[node.icon]} />
                    }
                    <span className='v2-workspace__left-list-text'>{nodeName}</span>
                </>
            )
        } else {
            return <span className={`${addExtraIndentation ? 'v2-workspace__left-list-name-extra-indentation ' : ''}v2-workspace__left-list-text`}>{nodeName}</span>;
        }
    }

    const [rightClickedNode, setRightClickedNode] = useState(null);
    const nodeListRightClicked = (e, node, nodes, onDone) => {
        setRightClickedNode(node);
        
        const rightClickMenu = [];

        if (node.removable) {
            rightClickMenu.push({
                label: "Delete " + node.name,
                action: (e) => {
                    // console.log("Delete clicked for new format node: ", node);
                    removeVal(node.valsArray, node.dataIndex);
                    RIGHT_CLICK_MENU_CONTROLLER.hideRightClickMenu();
                }
            });
        }

        console.log("Right click menu items for node: ", node, rightClickMenu);

        if (rightClickMenu.length) {
            e.preventDefault();
            RIGHT_CLICK_MENU_CONTROLLER.showRightClickMenu(e, rightClickMenu, () => { NODE_LIST_CONTROLLER.refreshNodeList("new-format-nodes-list"); onDone(); });
            return true; // We handled the right click
        } else {
            console.warn("No right click menu items available for new format node: ", node);
            RIGHT_CLICK_MENU_CONTROLLER.hideRightClickMenu();
            return false; // We did not handle the right click
        }
    }

    const [showFontSelector, setShowFontSelector] = useState(false);
    const fontSelectedFunc_ref = useRef(null);
    const currentFont_ref = useRef(null);
    const openFontSelector = (currentFont, selectedFunc) => {
        currentFont_ref.current = currentFont;
        fontSelectedFunc_ref.current = selectedFunc;
        setShowFontSelector(true);
    }
    const closeFontSelector = () => {
        setShowFontSelector(false);
    }

    const [showCustomFontSelector, setShowCustomFontSelector] = useState(false);
    const openCustomFontSelector = () => {
        setShowCustomFontSelector(true);
    }
    const closeCustomFontSelector = () => {
        setShowCustomFontSelector(false);
    }

    useEffect(() => {
        initGoogleFonts();
    }, []);

    // Temporary image upload popup
    const [showTemporaryImageUploadPopup, setShowTemporaryImageUploadPopup] = useState(false);
    const [imageFileData, setImageFileData] = useState(null);
    const [imagePopupLabel, setImagePopupLabel] = useState('');
    const [imagePopupLabelNote, setImagePopupLabelNote] = useState('');
    const openTemporaryImageUploadPopup = (fileData, label, labelNote) => {
        setImageFileData(fileData);
        setImagePopupLabel(label);
        setImagePopupLabelNote(labelNote);
        setShowTemporaryImageUploadPopup(true);
    }
    const closeTemporaryImageUploadPopup = () => {
        setShowTemporaryImageUploadPopup(false);
        setImageFileData(null);
        setImagePopupLabel('');
        setImagePopupLabelNote('');
    }

    // Temporary audio upload popup
    const [showTemporaryAudioUploadPopup, setShowTemporaryAudioUploadPopup] = useState(false);
    const [audioFileData, setAudioFileData] = useState(null);
    const [audioPopupLabel, setAudioPopupLabel] = useState('');
    const openTemporaryAudioUploadPopup = (fileData, label) => {
        setAudioFileData(fileData);
        setAudioPopupLabel(label);
        setShowTemporaryAudioUploadPopup(true);
    }
    const closeTemporaryAudioUploadPopup = () => {
        setShowTemporaryAudioUploadPopup(false);
        setAudioFileData(null);
        setAudioPopupLabel('');
    }

    return (
        <div className="v2-workspace">
            <div className="v2-workspace__left-list-container">
                { leftListItems && leftListItems.length > 0 &&
                    <>
                        <NodeList
                            id='customisation-workspace-left-list'
                            nodes={leftListItems}

                            indentation='1.5rem'

                            expandNodeElement={
                                <img className='v2-workspace__left-list-chev-icon' alt='' src={WORKSPACE_LEFT_LIST_ICONS.nodeClosed} />
                            }
                            collapseNodeElement={
                                <img className='v2-workspace__left-list-chev-icon' alt='' src={WORKSPACE_LEFT_LIST_ICONS.nodeOpen} />
                            }

                            renderNodeName={renderNodeName}
                            getSubNodes={getSubNodes}

                            onNodeClick={(e, node, nodes) => {
                                // console.log("Node clicked:", node);
                                if (node.isAddButton) {
                                    // console.log("Add button clicked - add new node:", node);
                                    addVal(node.valsArray, node.varSchema.valSchema, node.featureData.feature);
                                } else
                                if (node.depth === 0) {
                                    // console.log("Node clicked - select node:", node);
                                    if (selectedFeatureId !== node.id) {
                                        setSelectedFeatureId(node.id);
                                        setSelectedFeatureNode(node);
                                        
                                        // Find a visualised group node in the subNodes if we have one
                                        const visualisedGroupNode = node.subNodes.find(subNode => subNode.isVisualised);
                                        if (visualisedGroupNode) {
                                            activateNode(visualisedGroupNode);
                                            setTimelinePlayheadStep(visualisedGroupNode.config.visualisationConfig.startStep || 0);
                                        } else {
                                            clearActiveNode();
                                        }

                                        setTimelinePlayheadStep(0);
                                    }
                                    // Return true to select this node
                                    return true;
                                } else if (node.topNode) {
                                    // console.log("Node clicked - select top node:", node.topNode);
                                    if (selectedFeatureId !== node.topNode.id) {
                                        setSelectedFeatureId(node.topNode.id);
                                        setSelectedFeatureNode(node.topNode);
                                        NODE_LIST_CONTROLLER.selectNodeByIdAndPath('customisation-workspace-left-list', node.topNode.id, node.topNode.path, false, false, false);
                                    }
                                    if (!node.active) {
                                        activateNode(node);
                                    }
                                }
                                forceUpdateComponent();
                                return false;
                            }}

                            enableRightClickMenu={true}
                            onNodeRightClick={(e, node, nodes, onDone) => {
                                return nodeListRightClicked(e, node, nodes, onDone);
                            }}
                        />
                        {selectedFeatureNode &&
                            <button className='standard-button' onClick={() => {setPreviewMode(true)}}>Preview</button>
                        }
                    </>
                }
            </div>
            <div className="v2-workspace__right-panel">
                <div className="v2-workspace__right-panel__top">
                    <div className="v2-workspace__right-panel__top__preview-container">
                        <EditablePreview
                            campaignData={campaignData}
                            customisationVars={customisationVars}
                            selectedFeatureId={selectedFeatureId}
                            selectedFeatureNode={selectedFeatureNode}
                            activeNode={activeNode}
                            visualisedNode={activeVisualisedPreviewNode}
                            timelinePlayheadStep={timelinePlayheadStep}
                            activateNodeFunction={activateNode}
                            forceUpdateComponent={forceUpdateComponent}
                            forceUpdate={forceUpdate}
                        />
                    </div>
                    <div className="v2-workspace__right-panel__customisation-modules-container">
                        {(activeNode || activateTimelineAudioGroup) &&
                            <>
                            {activeNode &&
                                <h5>{activeNode.parent.name} {'>'} {activeNode.name}</h5>
                            }
                            {activeTimelineAudioGroup &&
                                <h5>Timeline Audio &gt; {activeTimelineAudioGroup.audioData.name}</h5>
                            }
                                <ModuleList
                                    campaignData={campaignData}
                                    selectedFeatureNode={selectedFeatureNode}
                                    activeNode={activeNode}
                                    activeTimelineAudioGroup={activeTimelineAudioGroup}
                                    groupConfig={activeNode?.config}
                                    customisationVars={activeNode?.customisationVars || customisationVars?.current?.[selectedFeatureId] || {}}
                                    openFontSelector={openFontSelector}
                                    openCustomFontSelector={openCustomFontSelector}
                                    openTemporaryImageUploadPopup={openTemporaryImageUploadPopup}
                                    openTemporaryAudioUploadPopup={openTemporaryAudioUploadPopup}
                                    forceUpdateComponent={forceUpdateComponent}
                                    forceUpdate={forceUpdate}
                                />
                            </>
                        }
                    </div>
                </div>
                <div className="v2-workspace__right-panel__timeline-container">
                    <Timeline
                        campaignData={campaignData}
                        customisationVars={customisationVars}
                        selectedFeatureId={selectedFeatureId}
                        selectedFeatureNode={selectedFeatureNode}
                        activeNode={activeNode}
                        activateNodeFunction={activateNode}
                        visualisedNode={activeVisualisedPreviewNode}
                        timelinePlayheadStep={timelinePlayheadStep}
                        setTimelinePlayheadStep={setTimelinePlayheadStep}
                        activeTimelineAudioGroup={activeTimelineAudioGroup}
                        activateTimelineAudioGroup={activateTimelineAudioGroup}
                        forceUpdateComponent={forceUpdateComponent}
                        forceUpdate={forceUpdate}
                    />
                </div>
            </div>
            {showFontSelector &&
                <FontSelectorPopup
                    closePanelFunc={closeFontSelector}
                    selectFunc={fontSelectedFunc_ref.current}
                    font={currentFont_ref.current}
                    customFonts={campaignData.customFonts}
                    campaignId={campaignData._id}
                />
            }
            {showCustomFontSelector &&
                <CustomFontsPopup
                    closePanelFunc={closeCustomFontSelector}
                    customFonts={campaignData.customFonts}
                    campaignId={campaignData._id}
                    fullCampaignData={campaignData}
                />
            }
            {showTemporaryImageUploadPopup &&
                <TemporaryImageUploadPopup
                    closePanelFunc={closeTemporaryImageUploadPopup}
                    varVal={imageFileData}
                    controlLabel={imagePopupLabel}
                    labelNote={imagePopupLabelNote}
                    onComplete={() => {
                        closeTemporaryImageUploadPopup();
                        forceUpdateComponent();
                    }}
                />
            }
            {showTemporaryAudioUploadPopup &&
                <TemporaryAudioUploadPopup
                    closePanelFunc={closeTemporaryAudioUploadPopup}
                    varVal={audioFileData}
                    controlLabel={audioPopupLabel}
                    onComplete={() => {
                        closeTemporaryAudioUploadPopup();
                        forceUpdateComponent();
                    }}
                />
            }
            {previewMode &&
                <FeaturePreview
                    campaignId={campaignData._id}

                    currentFeature={selectedFeature}
                    titlePostFix={"Preview"}
                    featureVars={featureVars}
                    streamId={null}
                    customisationVars={customisationVars}
                    closeFunc={() => setPreviewMode(false)}

                    startControlsExpanded={true}
                    startMaximized={false}
                    resizeable={true}
                    startPosX={'right'}
                    showQuickPlayButton={true}
                    autoStart={true}
                    previewUpdate={null}

                    // _reportFeatureVarsChanged={reportFeatureVarsChanged}
                    // _reportCustomisationVarsChanged={reportCustomisationVarsChanged}
                    
                    _sendFeatureCommandFunc={sendFeatureCommand}
                    // _showTooltip={showTooltip}
                    // _hideTooltip={hideTooltip}
                />
            }
        </div>
    );
}

export default CustomisationWorkspaceMain;
